import React, { useState } from 'react';
import axios from '../../utils/axios';
import { TextField, Button, Grid, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Footer from '../Partial/footer/footer';
import Navbar from '../Partial/navbar/Navbar';
//axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('authToken')}`;

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post('/users/login', {email: email, password: password})
      //console.log('Login successful:', response);
      if (response.data.token) {
        // Save the token in localStorage
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('userRole', response.data.role);
        // successful login redirects to a dashboard or homepage
        navigate('/');  
      }
    } catch (error) {
      console.error('Login failed:', error);
      if (error.response) {
      // Handle the error appropriately: this means the request was made and the server responded with a status code; that falls out of the range of 2xx
        alert(error.response.data.message || 'Login failed. Please try again!');
      } else if (error.request) {
        // The request was made but no response was received
        alert('No response from server. Please check your connection.');
      } else {
        // Something happened in setting up the request that triggered an Error
        alert('Error in login process. Please try again later.');
      }
      } finally {
      setLoading(false);
      }
        };

  return (
    <Container maxWidth={false} disableGutters>
      <Navbar />
      <div className="container-fluid">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Email Field */}
            <Grid item xs={12}>
              <TextField
                label="Email Address"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Grid>

            {/* Password Field */}
            <Grid item xs={12}>
              <TextField
                label="Password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
              />
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={loading}
              >
                {loading ? 'Logging In...' : 'Login'}
              </Button>
            </Grid>
          </Grid>
        </form>

        {/* New User Redirect Button */}
        <Grid container justifyContent="center" style={{ marginTop: '1rem' }}>
          <Typography variant="body1" style={{ marginRight: '10px' }}>
            Don't have an account?
          </Typography>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate('/signUp')}
          >
            Sign Up
          </Button>
        </Grid>
      </div>
      <Footer />
    </Container>
  );
};

export default LoginPage;
